import React from 'react'
import { PlainField } from './PlainField';

const EmailField = ({ ...props }) => {
	props.type = 'email';
	props.fieldType = 'email';
	return (<PlainField {...props} />)
}

export default EmailField